import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { GhostIcon } from 'lucide-react'

import { Button } from '@/shared/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/ui/card'

type ClientNotFoundProps = {
    additionalActions?: React.ReactNode
}

export const ClientNotFound = ({ additionalActions }: ClientNotFoundProps) => {
    const navigate = useNavigate()

    const { t } = useTranslation(undefined, { keyPrefix: 'clientNotFound' })

    return (
        <div className='container mx-auto flex h-[80vh] items-center justify-center p-6'>
            <Card className='w-full max-w-md text-center'>
                <CardHeader>
                    <div className='mx-auto mb-4 rounded-full bg-orange-100 p-3'>
                        <GhostIcon className='h-6 w-6 text-orange-500' />
                    </div>
                    <CardTitle className='text-2xl font-bold text-gray-900'>{t('title', 'Client not found')}</CardTitle>
                </CardHeader>
                <CardContent className='space-y-4'>
                    <p className='text-gray-500'>
                        {t(
                            'description',
                            'We are sorry, we have not been able to find the client you are looking for. The link may be incorrect or the client has been deleted.',
                        )}
                    </p>
                    <div className='flex flex-col gap-2'>
                        <Button onClick={() => navigate(-1)} variant='outline'>
                            {t('back', 'Back')}
                        </Button>
                        {additionalActions && additionalActions}
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}
